var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M64 6c32.033 0 58 25.967 58 58s-25.967 58-58 58S6 96.033 6 64 31.967 6 64 6m7.373 40.724H56.675v55.452h14.698zM64 25q-8 0-8 7.39 0 3.522 2 5.481c2 1.959 3.333 1.96 6 1.96q8 0 8-7.44 0-7.392-8-7.391"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;